import React, { FC } from 'react';

import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListButtonsAnchor: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListButtonsAnchor.slug = block.slug;
ListButtonsAnchor.title = block.title;
